import { AdminFunnelPlatform, GetAdminFunnelResponse } from '@orbit/api-types'
import { useAdminFilter } from '@pages/Admin/AdminFilterContext'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

/**
 * Fetches the admin activation funnel (GET /v1/admin/funnel) for the devices
 * first seen in the global date range from {@link useAdminFilter}, narrowed to
 * `platform`. Every input is part of the query key, so changing any refetches,
 * and the previous funnel stays on screen while the next one loads. Gated
 * server-side by the AdminGuard; non-admins receive 403.
 */
export const useAdminFunnel = (platform: AdminFunnelPlatform) => {
	const { from, to, includeInternal } = useAdminFilter()

	return useQuery<GetAdminFunnelResponse>({
		queryKey: queryKeys.adminFunnel(from, to, platform, includeInternal),
		queryFn: async () => {
			const response = await api.get<GetAdminFunnelResponse>('/admin/funnel', {
				params: {
					from,
					to,
					platform: platform === 'all' ? undefined : platform,
					includeInternal: includeInternal || undefined,
				},
			})
			return response.data
		},
		placeholderData: keepPreviousData,
	})
}
